import BaseModelRequest from '../communicate/BaseModelRequest'

export default class OtpRequest extends BaseModelRequest{

  getModelName () {
    return "otp";
  }

  verifyOTP(data) {
    const url = "verify/otp";
    return this.post(url, data);
  }

  getOTP(phone) {
    const url = "get/otp";
    return this.post(url, phone);
  }
}



// WEBPACK FOOTER //
// ./src/request/OtpRequest.js